import { format, isMatch, parse } from "date-fns";
import { API_DATE_STRING_FORMAT, DATE_STRING_FORMAT } from "../Constants/stringFormats";

const decimalToFlag = (stringFloatFlag) => {
  if (stringFloatFlag === null || stringFloatFlag === undefined) return null;

  if (stringFloatFlag == '0.0000') {
    return 'N';
  }
  return 'Y';
};


const cleanUpNumberString = (value) => {
  if (value === undefined || value === null) return null;
  return value.toString().replace('$', '').replace(/,/g, '').replace('%').trim();
}

const stringNumberToFlag = (value) => {
  const cleanedValue = cleanUpNumberString(value);
  if (isNaN(cleanedValue) || cleanedValue === null) return value;

  const parsedValue = Number(cleanedValue);
  return parsedValue === 1 ? 'Y' : parsedValue === 0 ? 'N' : value; 
}

const formatStringAsCurrency = (value, useParenthesisNegativeFormat) => {
  const cleanedUpValue = cleanUpNumberString(value)

  // if, after clearning it up it's not numeric, then just return null
  if (isNaN(cleanedUpValue) || cleanedUpValue === null) return null;

  const dollars = new Intl.NumberFormat('en-US', {
    currency: `USD`,
    style: 'currency',

  });

  const formattedParts = dollars.formatToParts(Number(cleanedUpValue));

  // this custom formatting assumes USD format where the symbol
  // is at the beginning and the end is the decimal portion
  if (useParenthesisNegativeFormat && formattedParts.some(fp => fp.type === 'minusSign')) {
    const customParts = [];
    for(const part of formattedParts) {
      if (part.type === 'minusSign') {
        customParts.push('(');
      } else {
        customParts.push(part);
      }
    }
    customParts.push(')');

    return customParts.join('');
  }

  return formattedParts.map(fp => fp.value).join('');
}

const formatStringWithPrecision = (value, precision, truncated) => {
  const cleanedUpValue = cleanUpNumberString(value);

  if (isNaN(cleanedUpValue) || cleanedUpValue === null) return value;

  const parsed = Number(cleanedUpValue);
  if (!truncated) {
    return parsed.toFixed(precision);
  } 

  return (parseInt(parsed * 10) / 10).toString();
}


const formatStringAsPercent = (value) => {
  const cleanedUpValue = cleanUpNumberString(value)

  // if, after clearning it up it's not numeric, then just return null
  if (isNaN(cleanedUpValue) || cleanedUpValue === null) return null;
  
  return `${Number(cleanedUpValue) * 100}%`;
}

const regex = /(\.\d{2})(\d*)/i;
const cleanNumericString = (stringToClean, dSign) => {
  if (stringToClean == null || stringToClean === undefined) return null;
  if (!dSign) dSign = '$';
  let stringClean = dSign + stringToClean;
  stringClean = stringClean.replace('$-', '-$');
  return stringClean.replace(regex, '$1');
};

const formatDateStringIfMatches = (dateString, incomingFormat, outgoingFormat) => {
  if (!dateString || !isMatch(dateString, incomingFormat)) return null;
  return formatDateString(dateString, incomingFormat, outgoingFormat);
};

const formatDateString = (dateString, incomingFormat, outgoingFormat) => {
  const date = parseDate(dateString,incomingFormat);
  if (!date){
    return null;
  }
  return format(date, outgoingFormat);
}

const parseDate = (dateString, incomingFormat) => {
  if (!dateString) return null;

  const date = parse(dateString, incomingFormat, new Date());

  if (isNaN(date)) {
    console.warn('Received Invalid Date:', dateString, 'Parsed:', date);
    return null;
  };

  return date;
}

const getDefaultDateString = () => {
  return format(new Date(), DATE_STRING_FORMAT);
};

const excelErrors = ['#N/A', '#VALUE', '#REF', '#DIV/0'];
const containsExcelErrors = (stringResult) => {
  return excelErrors.some(er => stringResult.indexOf(er) !== -1);
};

const convertDateIfApplicable = (date) => {
  if (isMatch(date, API_DATE_STRING_FORMAT)) {
      const parsedDate = parse(date, API_DATE_STRING_FORMAT, new Date());
      if (isNaN(parsedDate)) {
        return date;
      }
      
      return format(parsedDate, DATE_STRING_FORMAT);
  }
  
  return date;
}

export { 
  decimalToFlag, 
  cleanNumericString, 
  formatDateString, 
  formatStringAsCurrency, 
  cleanUpNumberString, 
  formatStringAsPercent,
  stringNumberToFlag,
  formatStringWithPrecision,
  getDefaultDateString,
  formatDateStringIfMatches,
  containsExcelErrors,
  convertDateIfApplicable,
  parseDate
};